import React from 'react';
import { useNavigate } from 'react-router-dom';
import './legal.css';

// NEW: SEO
import SEO from '../components/SEO';

const TermsOfService = () => {
  const navigate = useNavigate();

  return (
    <div
      className="terms-of-service"
      style={{ padding: "2rem", maxWidth: "800px", margin: "auto" }}
    >
      {/* SEO: meta for Terms of Service page */}
      <SEO
        title="Terms of Service - Talkvee"
        description="Read the Terms of Service for Talkvee. Understand our rules for safe behavior, privacy, moderation, and responsibilities when using our random video chat."
        pathname="/terms"
        robots="index, follow"
      />

      <button className="back-button" onClick={() => navigate(-1)}>← Back</button>

      <h1>Terms of Service for Talkvee</h1>
      <p><strong>Last Updated:</strong> 01/05/2025</p>

      <h2>1. Acceptance of Terms</h2>
      <p>
        By using Talkvee (“we”, “our”, or the “Service”), you agree to these Terms of Service and our Privacy Policy. If you do not agree, please do not use the Service.
      </p>

      <h2>2. Description of Service</h2>
      <p>
        Talkvee is a random video chat platform that connects users anonymously or through social login. We provide real-time communication between users through video and audio. These sessions are temporary and are <strong>not recorded or stored</strong>.
      </p>

      <h2>3. Age Requirement</h2>
      <p>
        You must be at least 18 years old to use Talkvee. By using the Service, you confirm that you meet this requirement.
      </p>

      <h2>4. User Conduct</h2>
      <ul>
        <li><strong>Respectful Behavior:</strong> You must treat all users with respect. Harassment, threats, hate speech, discrimination, or sexually explicit behavior is strictly prohibited.</li>
        <li><strong>Prohibited Content:</strong> Sharing or displaying illegal, obscene, or abusive content will result in immediate action, including permanent bans.</li>
        <li><strong>No Recording:</strong> You may not record, screenshot, or share any part of a chat without the clear consent of all parties involved.</li>
        <li><strong>Illegal Use:</strong> You may not use Talkvee for any unlawful, harmful, or fraudulent purpose.</li>
        <li><strong>Protect Your Privacy:</strong> You must not share personal or sensitive information (such as your full name, address, phone number, financial data, or passwords) with other users. <strong>Talkvee is not responsible</strong> for any consequences resulting from voluntarily shared personal data during a conversation.</li>
      </ul>

      <h2>5. Moderation and Bans</h2>
      <p>
        To protect the community, Talkvee reserves the right to suspend or permanently ban users who violate these terms. We may use login IDs or generated guest identifiers to enforce such actions. Appeals can be submitted via email.
      </p>

      <h2>6. Data Handling</h2>
      <p>
        By using Talkvee, you agree to the practices described in our <a href="/privacy">Privacy Policy</a>. We collect minimal data for account access and moderation. We do not store media or share user information with third parties.
      </p>

      <h2>7. Disclaimer of Warranty</h2>
      <p>
        Talkvee is provided “as is” and “as available” without warranties of any kind. We do not guarantee uninterrupted service, and we are not liable for any issues arising from use of the platform, including interactions with other users.
      </p>

      <h2>8. Limitation of Liability</h2>
      <p>
        To the fullest extent permitted by law, Talkvee and its developers will not be held responsible for any damages or losses resulting from your use of the Service.
      </p>

      <h2>9. Changes to Terms</h2>
      <p>
        We may update these Terms at any time. If we do, we will update the “Last Updated” date at the top of this page. Your continued use of Talkvee means you accept the new terms.
      </p>

      <h2>10. Contact Us</h2>
      <p>
        For questions or concerns regarding these Terms of Service, please contact us at <a href="mailto:contact@talkvee.com">contact@talkvee.com</a>.
      </p>
    </div>
  );
};

export default TermsOfService;
